// import * as React from 'react';
// import { useState, useRef, useEffect, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { setUserSession, getApiHeaderGuest } from '../../utils/CommonFunctions';
// import { Link, withRouter} from "react-router-dom";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import LogoImg from '../../assets/media/esim/esim_logo.png'
// import LogoWhite from '../../assets/img/logowhite.png';
// import {Skeleton, Snackbar} from '@mui/material';
// import MuiAlert from '@mui/material/Alert';
// import Login from './Login';
// import Register from './Register';
// import { UserAPI } from '../../services';
// import {Validate, Colors, Constants, Languages} from '../../common';
// import { actions } from '../../redux/UserRedux';
// import bac from  '../../assets/img/background.png'
// import  LoginScreen from "../../../src/assets/img/image.png"
// import  Logo from "../../../src/assets/img/logowhite.png"

// const headers 		= getApiHeaderGuest();

// const Alert = React.forwardRef(function Alert(props, ref) {
//     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });

// const Auth = () => {

//     const dispatch = useDispatch();

//     const [isLoading, setIsLoading] = useState(false);
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [isLogin, setIsLogin] = useState(true)
//     const [showPassword, setShowPassword] = useState(false)
//     const [open, setOpen] = useState(false);
//     const [message, setMessage] = useState("");
//     const [msgType, setMsgType] = useState(Constants.SnackBarType.Error); 
//     const [rFirstName, setRFirstName] = useState("");
//     const [rLastName, setRLastName] = useState("");
//     const [rUserName, setRUserName] = useState("");
//     const [rPassword, setRPassword] = useState("");
//     const [rCPassword, setRCPassword] = useState("");
//     const [rSessionId, setRSessionId] = useState(null);
//     const [isVerified, setIsVerified] = useState(false);
//     const [sendOTP, setSendOTP] = useState(false)


//     const clearData = useCallback(() => {
//         dispatch(actions.clearData());
//     }, [dispatch]);

//     const notAvailable = useCallback(() => {
//         actions.notAvailable(dispatch);
//     }, [dispatch]);

//     const setActivationId = useCallback((activationId, eSIMName) => {
//         dispatch(actions.setActivationId(activationId, eSIMName));
//     }, [dispatch]);

//     const onEmailEditHandle = (event) => {
//         setEmail(event.target.value);
//     }

//     const onPasswordEditHandle = (event) => {
//         setPassword(event.target.value);
//     }

//     const validateForm = () => {
//         console.log(email, password);
//         if(Validate.isEmpty(email, password)){
//             return Languages.LoginError;
//         }else if(!Validate.isEmail(email)){
//           return Languages.EmailError;
//         }
//         return undefined;
//     }

//     const getActivations = async (headers) => {
//         setIsLoading(true)
//         const response = await UserAPI.postData({}, headers, Constants.UserActivations)
//         console.log('UserActivations ==>', response);
//         if(response !== undefined){
//             if(response.status == 200){
//                 if(response.data.activations.length > 0){
//                     //setIsLoading(false);
//                     let data 		= response.data.activations; 
//                     let esim_Name = '';
//                     let activation_Id = 0
//                     if(data.length > 0){
//                         esim_Name = data[0].country_name + ' - ' + data[0].iccid;
//                         activation_Id = data[0].activation_id
//                     }
//                     await setActivationId(activation_Id, esim_Name)  
//                 }else{
//                     await notAvailable();
//                 }
                
//             } else {
//                 //setIsLoading(false)
//                 showMsg(response.message, Constants.SnackBarType.Warning)
//             }
//         }else {
//             //setIsLoading(false)
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     };

//     const gotoHome = async (response) => {
//         const header    =   await {
//             'Authorization': 'Bearer ' + response.data.token,
//             'api-token': Constants.ApiToken,
//             'device-type': 'Web'
//         };
//         getActivations(header);
//         setIsLoading(true)
//         let p = new Promise((resolve, reject)=>{
//             setUserSession(response.data.token, response.data.user);
//             resolve();
//         })
//         p.then(
//             ()=>{
//                 //this.props.history.push("/home");
//                 setIsLoading(false)
//                 setSendOTP(false);
//                 window.location.href = "/home";
//             },
//             ()=>{
//                 setIsLoading(false)
//                 showMsg("Error in Login", Constants.SnackBarType.Warning)
//             }
//         )
//     }

//     //dummy data
//     const gotodummyHome = (response) => {
//         let p = new Promise((resolve, reject)=>{
//             setUserSession(Constants.SampleToken, Constants.SampleUser);
//             resolve();
//         })
//         p.then(
//             ()=>{
//                 //this.props.history.push("/home");
//                 setIsLoading(false)
//                 window.location.href = "/home";
//             },
//             ()=>{
//                 setIsLoading(false)
//                 showMsg("Error in Login", Constants.SnackBarType.Warning)
//             }
//         )
//     }

//     const onLogin = async (username, password) => {
//         setIsLoading(true)
//         await clearData();
//         // gotodummyHome();
//         const data = {
//             username: username,
//             password: password
//         }
//         const response = await UserAPI.postData(data, headers, Constants.Login)
//         console.log('login ==>', response);
//         if(response !== undefined){
//             if(response.status == 200){
//                 showMsg(response.message, Constants.SnackBarType.Success)
//                 gotoHome(response);
//             } else if(response.status == 422){
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key=>response.message[key][0])
//                 setIsLoading(false)
//                 showMsg(arr, Constants.SnackBarType.Warning)
//             }else{
//                 setIsLoading(false)
//                 showMsg(response.message, Constants.SnackBarType.Warning)
//             }
//         }else {
//             setIsLoading(false)
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     }

//     const onLoginPressHandle = async () => {
//         const error = validateForm();
//         if(error) return showMsg(error, Constants.SnackBarType.Warning);
//         onLogin(email, password);
//     }

//     const onVerifyEmailToHome = async () => {
//         setIsLoading(true)
//         var data = {
//             firstname: rFirstName,
//             lastname: rLastName,
//             email: rUserName,
//             password: rPassword,
//             password_confirmation: rCPassword,
//             session_id: rSessionId
//         }
//         var url = Constants.VerifyeSIM;
//         const response = await UserAPI.postData(data, headers, url)
//         if(response !== undefined){
//             if(response.status == 200){
//                 showMsg(response.message, Constants.SnackBarType.Success);
//                 gotoHome(response);
//                 setIsLoading(false)
//             } else if(response.status == 422){
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key=>response.message[key][0])
//                 setIsLoading(false)
//                 showMsg(arr, Constants.SnackBarType.Warning)
//             } else {
//                 setIsLoading(false)
//                 showMsg(response.message, Constants.SnackBarType.Warning)
//             }
//         }else {
//             setIsLoading(false)
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     }

//     const onRegister = async (firstname, lastname, username, password, conPass, otp) => {
//         setIsLoading(true)
//         await clearData();
//         var data = {
//             firstname: firstname,
//             lastname: lastname,
//             email: username,
//             password: password,
//             password_confirmation: conPass
//         }
//         var url = Constants.Register;
//         if(sendOTP == true && username == rUserName && password == rPassword){
//             data = {
//                 email: rUserName,
//                 otp: otp,
//                 session_id: rSessionId
//             };
//             url = Constants.VerifyRegisterOTP;
//         }
//         const response = await UserAPI.postData(data, headers, url)
//         console.log('Register ==>', response);
//         if(response !== undefined){
//             if(response.status == 200){
//                 showMsg(response.message, Constants.SnackBarType.Success);
//                 if(sendOTP == false){
//                     setRSessionId((response.data.session_id !== undefined && response.data.session_id != null) ? response.data.session_id : null)
//                     setRCPassword(conPass);
//                     setRFirstName(firstname);
//                     setRLastName(lastname);
//                     setRPassword(password);
//                     setRUserName(username);
//                     setIsVerified(true);
//                     setSendOTP(true);
//                     setIsLoading(false)
//                 } else {
//                     onVerifyEmailToHome();
//                 }
                
                
//                 //gotoHome(response);
//             } else if(response.status == 422){
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key=>response.message[key][0])
//                 setIsLoading(false)
//                 showMsg(arr, Constants.SnackBarType.Warning)
//             } else {
//                 setIsLoading(false)
//                 showMsg(response.message, Constants.SnackBarType.Warning)
//             }
//         }else {
//             setIsLoading(false)
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     }

//     //show messages
//     const showMsg = (message, type) => {
//         setMessage(message);
//         setMsgType(type);
//         setOpen(true);
//     }
    
//     const handleClose = (event, reason) => {
//         // if (reason === 'clickaway') {
//         //   return;
//         // }
//         setOpen(false);
//     };
    
//     return(
//         // <div className="kt-grid kt-grid--ver kt-grid--root login">
//         //     <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ 'horizontal': 'center', 'vertical': 'top'}}>
//         //         <Alert onClose={handleClose} severity={msgType} sx={{ width: '100%' }} style={{fontSize: sendOTP == true ? 16 : 14}}>
//         //         {message}
//         //         </Alert>
//         //     </Snackbar>
//         //     <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid kt-grid--hor kt-login-v2 backImage login" id="kt_login_v2">
//         //         <div className="kt-grid__item  kt-grid  kt-grid--ver  kt-grid__item--fluid loginCenterView">
//         //             <div>
//         //                 <div className='authHideView' style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 50}}>
//         //                     <img style={{height: 70, width: 150}} src={LogoWhite} alt="" />
//         //                 </div>
                        
//         //                 <div className='hideMobileView' style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 50}}>
//         //                     <img style={{height: 70, width: 150}} src={LogoImg} alt="" />
//         //                 </div>
                        
//         //                 {/* authHideView */}
//         //                 <div className='boxView authHideView'> 
                        
//         //                     <form className="loginForm">
                            
//         //                     {isLoading == false ? (<div className='headerView rowView'>
//         //                             <div className='headerItem centerView pointer' style={{backgroundColor: isLogin == true ? Colors.White : Colors.Secondary, fontWeight: isLogin == true ? 600 : 400}} onClick={()=>{
//         //                                 setIsLogin(true)
//         //                                 setSendOTP(false)
//         //                                 }}>
//         //                                 {Languages.Login}
//         //                             </div>
                                    
//         //                             <div className='headerItem centerView pointer' style={{backgroundColor: isLogin == false ? Colors.White : Colors.Secondary, fontWeight: isLogin == false ? 600 : 400}} onClick={()=>{
//         //                                 setIsLogin(false)
//         //                                 setSendOTP(false)
//         //                                 }}>
//         //                                 {Languages.Register}
//         //                             </div>

//         //                         </div>) : (
//         //                             <div className='headerView rowView' style={{borderTopLeftRadius: 10, borderTopRightRadius: 10,backgroundColor: Colors.White}}>
//         //                                 <Skeleton animation="wave" sx={{ marginLeft: 1, marginTop: 1}} variant="rectangular" width={225} height={48}/>
//         //                                 <Skeleton animation="wave" sx={{ marginLeft: 1, marginRight: 1, marginTop: 1}} variant="rectangular" width={225} height={48}/>
//         //                             </div>
//         //                         )}
//         //                        { isLogin == true ? (
//         //                         <Login 
//         //                         isLoading={isLoading}
//         //                         showMsg={(msg)=>showMsg(msg, Constants.SnackBarType.Warning)}
//         //                         onLogin={onLogin}/>
//         //                         ) : (
//         //                         <Register 
//         //                         isLoading={isLoading}
//         //                         onRegister={onRegister}
//         //                         showMsg={(msg)=>showMsg(msg, Constants.SnackBarType.Warning)}
//         //                         sendOTP={sendOTP}/>
//         //                        )}
//         //                     </form>
//         //                 </div>
//         //                 <div className='mBoxView hideMobileView'> 
//         //                     <form className="mLoginForm">
//         //                         {isLoading == false ? (<div className='mHeaderView rowView'>
//         //                             <div className='mHeaderItem centerView pointer' style={{backgroundColor: isLogin == true ? Colors.White : Colors.Secondary, fontWeight: isLogin == true ? 600 : 400}} onClick={()=>{
//         //                                 setIsLogin(true)
//         //                                 setSendOTP(false)
//         //                                 }}>
//         //                                 {Languages.Login}
//         //                             </div>
//         //                             <div className='mHeaderItem centerView pointer' style={{backgroundColor: isLogin == false ? Colors.White : Colors.Secondary, fontWeight: isLogin == false ? 600 : 400}} onClick={()=>{
//         //                                 setIsLogin(false)
//         //                                 setSendOTP(false)
//         //                                 }}>
//         //                                 {Languages.Register}
//         //                             </div>

//         //                         </div>) : (
//         //                             <div className='mHeaderView rowView' style={{backgroundColor: Colors.White}}>
//         //                             <Skeleton animation="wave" sx={{borderRadius: 1, marginLeft: 1, marginTop: 1, width: '48%'}} variant="rectangular" height={48}/>
//         //                             <Skeleton animation="wave" sx={{borderRadius: 1, marginLeft: 1, marginRight: 1, marginTop: 1, width: '48%'}} variant="rectangular" height={48}/>
//         //                         </div>
//         //                         )}
//         //                        { isLogin == true ? (
//         //                         <div className='loginForm' style={{backgroundColor: Colors.White, marginTop: -40, paddingTop: 40, paddingBottom: 30}}>
//         //                             <div className="form-group" style={{marginTop: 40}}>
//         //                                 {isLoading == false ? (<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 40}}>
//         //                                     {/* <i class="fa fa-envelope loginIcon" style={{color: '#D6060D'}}></i> */}
//         //                                     <input name="email" type='email' className="form-control" placeholder={Languages.Email} value={email} onChange={onEmailEditHandle} style={{borderWidth: 0, borderRadius: 5, backgroundColor: Colors.InputText, height: 48, marginRight: 40, marginLeft: 40,}}/>
//         //                                 </div>) : (
//         //                                     <Skeleton animation="wave" sx={{borderRadius: 1, marginLeft: 5, marginRight: 5, display: 'flex', flex: 1}} variant="rectangular" height={48}/>
//         //                                 )}
//         //                                 {/* {this.validator.message('email', this.state.email, 'required|email', { className: 'text-danger' })} */}
//         //                             </div>
//         //                             <div className="form-group">
//         //                                {isLoading == false ? ( <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5}}>
//         //                                     {/* <i class="fa fa-envelope loginIcon" style={{color: '#D6060D'}}></i> */}
//         //                                     <input type={showPassword == false ? "password" : 'text'} name="password" className="form-control" placeholder={Languages.Password} value={password} onChange={onPasswordEditHandle} style={{borderWidth: 0, borderRadius: 5, borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: Colors.InputText, height: 48, marginLeft: 40,}}/>
//         //                                     <div className='pointer' onClick={()=>{setShowPassword(!showPassword)}} style={{borderWidth: 0, borderTopRightRadius: 5, borderBottomRightRadius: 5, height: 48, backgroundColor: '#e5e5e5', marginRight: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', width: 48}}>{showPassword == false ? (<VisibilityIcon />) : (<VisibilityOffIcon />)}</div>
//         //                                 </div>) : (
//         //                                     <Skeleton animation="wave" sx={{borderRadius: 1, marginLeft: 5, marginRight: 5, display: 'flex', flex: 1}} variant="rectangular" height={48}/>
//         //                                 )}
//         //                                 {/* {this.validator.message('email', this.state.email, 'required|email', { className: 'text-danger' })} */}
//         //                             </div>
                                    
                                    
//         //                             <div className="form-group">
//         //                                 <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5}}>
//         //                                     {/* <i class="fa fa-envelope loginIcon" style={{color: '#D6060D'}}></i> */}
//         //                                     <label className="mlinkView" style={{justifyContent:'end'}}>
                                                
//         //                                     </label> 
//         //                                     <label className="mlinkView pointer" style={{justifyContent:'end'}}>
//         //                                         {isLoading == false ? (<Link to="/ForgotPassword" style={{color: Colors.Black}}>
//         //                                             {Languages.ForgotPassword}
//         //                                         </Link>) : (
//         //                                             <Skeleton animation="wave" variant="text" sx={{ fontSize: '1rem', display: 'flex', flex: 1 }} />
//         //                                         )}
//         //                                     </label> 
//         //                                 </div>
//         //                                 {/* {this.validator.message('email', this.state.email, 'required|email', { className: 'text-danger' })} */}
//         //                             </div>
//         //                             <div style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: -20}}>
//         //                                 {isLoading == false ? (<button type="button" className="btn btn-brand btn-elevate btn-pill pointer" style={{height: 48, borderRadius: 5, flex: 1, alignItems: 'center', justifyContent: 'center',marginRight: 40, marginLeft: 40}} onClick={onLoginPressHandle}>{Languages.Login}</button>
//         //                                 ) : (
//         //                                     <Skeleton sx={{ borderRadius: 1, marginLeft: 4, marginRight: 4, display: 'flex', flex: 1, bgcolor: Colors.Primary}} variant="rectangular" height={48}/>
//         //                                 )}
//         //                             </div>
//         //                             <div className="form-group" >
//         //                             <label className="form-check-label authInfo"  style={{color: Colors.White}}>{Languages.RegisterInfo1}
//         //                                 <Link to="" className="kt-link kt-link--brand" style={{color: Colors.White}}>
//         //                                     {Languages.TermsCondition}
//         //                                 </Link>{" and "}
//         //                                 <Link to="" className="kt-link kt-link--brand" style={{color: Colors.White}}>
//         //                                     {Languages.PrivacyPolicy}
//         //                                 </Link>
//         //                                 {Languages.RegisterInfo2}
//         //                             </label> 
//         //                             </div>
//         //                         </div>
                               
//         //                         ) : (
//         //                         <Register 
//         //                         isLoading={isLoading}
//         //                         onRegister={onRegister}
//         //                         showMsg={(msg)=>showMsg(msg, Constants.SnackBarType.Warning)}
//         //                         sendOTP={sendOTP}/>
//         //                        )}
//         //                     </form>
//         //                 </div>
//         //             </div>
//         //         </div>
//         //     </div>
//         // </div>

//        <>
//         <div className='container-fluid'>
//                 <div className='row' style={{height:"100vh"}}>
//                 <div className='col' style={{border:"2px solid red"}}>
//                   <img src= {LoginScreen} alt="Girl in a jacket" width="1000" height="1000"></img>          
//                 </div>
//                 <div className='col' style={{border:"2px solid red"}}>
//                      <div className='d-flex justify-content-center'>
//                   <img src= {Logo} alt="Girl in a jacket" width="100" height="100"></img>          
//                      </div>


//                    <div className='d-flex  justify-content-center  mt-3'>
//                     <div className='border border-transparent border-2 px-3 py-1 rounded'>
//                         <p className='fs-4'> Login </p>
                       
//                     </div>

//                     <div  className='border border-transparent border-2 px-3 py-1 rounded'>
//                         <p className='fs-4'>Register</p>
                      
//                     </div>

//                    </div>


//                    <div className='mt-2'>
//                     <p>Login </p>
//                     <form>
//                     <p>User Name</p>
//                       <input
//                       type="text"
//                       className='border border-rounded mb-2'
//                       placeholder
//                      />

//                   <p>password</p>
//                       <input
//                       type="password"
//                       className='border border-rounded mb-2'
//                       placeholder

//                      />
//                      <div className='mb-2'>
//                      <button> Sign In</button>
//                      </div>
//                     </form>
//                    </div>
//                    {/* Register */}
//                 <div>
//                 <form>
//                     <row>
//                     <div className=' col-6'>
//                         <p>First Name</p>
//                         <input
//                           type="text"
//                            placeholder='enter your name'
//                         />
//                     </div>


//                     <div className=' col-6'>
//                         <p> Last Name</p>
//                         <input
//                           type="text"
//                            placeholder='enter your name'
//                         />
//                     </div>
//                     </row>

//                     <row>
//                         <p> Email Address</p>
//                         <input
//                          type="email"
//                          placeholder='enter your email id'
//                         />

//                         <p> password</p>
//                         <input
//                          type="email"
//                          placeholder='enter your email id'
//                         />

//                        <p>Confirm password</p>
//                         <input
//                          type="email"
//                          placeholder='enter your email id'
//                         />

//                     </row>
//                     <p> otp</p>
//                     <input
//                     type="text"
//                     placeholder='enter your otp '
                    
                    
                    
//                     />
                    
//                     <div>
//                         <button> submit</button>
//                     </div>
                    
                    
//                     </form>
//                 </div>
//                 </div>
//                 </div>
//         </div>       
//        </>
//     );
// }
// export default Auth;


// import * as React from 'react';
// import { useState, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { setUserSession, getApiHeaderGuest } from '../../utils/CommonFunctions';
// import { Link } from "react-router-dom";
// import { UserAPI } from '../../services';
// import { Validate, Constants, Languages } from '../../common';
// import { actions } from '../../redux/UserRedux';
// import LoginScreen from "../../../src/assets/img/setimg.png";
// import Logo from "../../../src/assets/img/logowhite.png";

// const headers = getApiHeaderGuest();

// const Auth = () => {
//     const dispatch = useDispatch();

//     // State variables
//     const [isLoading, setIsLoading] = useState(false);
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [isLogin, setIsLogin] = useState(true);
//     const [showPassword, setShowPassword] = useState(false);
//     const [open, setOpen] = useState(false);
//     const [message, setMessage] = useState("");
//     const [msgType, setMsgType] = useState(Constants.SnackBarType.Error);
    
//     // Register fields
//     const [rFirstName, setRFirstName] = useState("");
//     const [rLastName, setRLastName] = useState("");
//     const [rUserName, setRUserName] = useState("");
//     const [rPassword, setRPassword] = useState("");
//     const [rCPassword, setRCPassword] = useState("");
//     const [rSessionId, setRSessionId] = useState(null);
//     const [isVerified, setIsVerified] = useState(false);
//     const [sendOTP, setSendOTP] = useState(false);
//     const [otp, setOtp] = useState("");

//     // Redux actions
//     const clearData = useCallback(() => {
//         dispatch(actions.clearData());
//     }, [dispatch]);

//     const notAvailable = useCallback(() => {
//         actions.notAvailable(dispatch);
//     }, [dispatch]);

//     const setActivationId = useCallback((activationId, eSIMName) => {
//         dispatch(actions.setActivationId(activationId, eSIMName));
//     }, [dispatch]);

//     // Validation functions
//     const validateForm = () => {
//         if (Validate.isEmpty(email, password)) {
//             return Languages.LoginError;
//         } else if (!Validate.isEmail(email)) {
//             return Languages.EmailError;
//         }
//         return undefined;
//     };

//     const validateRegisterForm = () => {
//         if (Validate.isEmpty(rFirstName, rLastName, rUserName, rPassword, rCPassword)) {
//             return "All fields are required";
//         } else if (!Validate.isEmail(rUserName)) {
//             return Languages.EmailError;
//         } else if (rPassword !== rCPassword) {
//             return "Passwords do not match";
//         }
//         return undefined;
//     };

//     // API call functions
//     const getActivations = async (headers) => {
//         setIsLoading(true);
//         const response = await UserAPI.postData({}, headers, Constants.UserActivations);
//         console.log('UserActivations ==>', response);
//         if (response !== undefined) {
//             if (response.status == 200) {
//                 if (response.data.activations.length > 0) {
//                     let data = response.data.activations;
//                     let esim_Name = '';
//                     let activation_Id = 0;
//                     if (data.length > 0) {
//                         esim_Name = data[0].country_name + ' - ' + data[0].iccid;
//                         activation_Id = data[0].activation_id;
//                     }
//                     await setActivationId(activation_Id, esim_Name);
//                 } else {
//                     await notAvailable();
//                 }
//             } else {
//                 showMsg(response.message, Constants.SnackBarType.Warning);
//             }
//         } else {
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     };

//     const gotoHome = async (response) => {
//         const header = await {
//             'Authorization': 'Bearer ' + response.data.token,
//             'api-token': Constants.ApiToken,
//             'device-type': 'Web'
//         };
//         getActivations(header);
//         setIsLoading(true);
//         let p = new Promise((resolve, reject) => {
//             setUserSession(response.data.token, response.data.user);
//             resolve();
//         });
//         p.then(
//             () => {
//                 setIsLoading(false);
//                 setSendOTP(false);
//                 window.location.href = "/home";
//             },
//             () => {
//                 setIsLoading(false);
//                 showMsg("Error in Login", Constants.SnackBarType.Warning);
//             }
//         );
//     };

//     const onLogin = async (username, password) => {
//         setIsLoading(true);
//         await clearData();
//         const data = {
//             username: username,
//             password: password
//         };
//         const response = await UserAPI.postData(data, headers, Constants.Login);
//         console.log('login ==>', response);
//         if (response !== undefined) {
//             if (response.status == 200) {
//                 showMsg(response.message, Constants.SnackBarType.Success);
//                 gotoHome(response);
//             } else if (response.status == 422) {
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key => response.message[key][0]);
//                 setIsLoading(false);
//                 showMsg(arr, Constants.SnackBarType.Warning);
//             } else {
//                 setIsLoading(false);
//                 showMsg(response.message, Constants.SnackBarType.Warning);
//             }
//         } else {
//             setIsLoading(false);
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     };

//     const onLoginPressHandle = async () => {
//         const error = validateForm();
//         if (error) return showMsg(error, Constants.SnackBarType.Warning);
//         onLogin(email, password);
//     };

//     const onVerifyEmailToHome = async () => {
//         setIsLoading(true);
//         var data = {
//             firstname: rFirstName,
//             lastname: rLastName,
//             email: rUserName,
//             password: rPassword,
//             password_confirmation: rCPassword,
//             session_id: rSessionId
//         };
//         var url = Constants.VerifyeSIM;
//         const response = await UserAPI.postData(data, headers, url);
//         if (response !== undefined) {
//             if (response.status == 200) {
//                 showMsg(response.message, Constants.SnackBarType.Success);
//                 gotoHome(response);
//                 setIsLoading(false);
//             } else if (response.status == 422) {
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key => response.message[key][0]);
//                 setIsLoading(false);
//                 showMsg(arr, Constants.SnackBarType.Warning);
//             } else {
//                 setIsLoading(false);
//                 showMsg(response.message, Constants.SnackBarType.Warning);
//             }
//         } else {
//             setIsLoading(false);
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     };

//     const onRegister = async (firstname, lastname, username, password, conPass, otpValue) => {
//         setIsLoading(true);
//         await clearData();
//         var data = {
//             firstname: firstname,
//             lastname: lastname,
//             email: username,
//             password: password,
//             password_confirmation: conPass
//         };
//         var url = Constants.Register;
        
//         if (sendOTP == true && username == rUserName && password == rPassword) {
//             data = {
//                 email: rUserName,
//                 otp: otpValue,
//                 session_id: rSessionId
//             };
//             url = Constants.VerifyRegisterOTP;
//         }
        
//         const response = await UserAPI.postData(data, headers, url);
//         console.log('Register ==>', response);
//         if (response !== undefined) {
//             if (response.status == 200) {
//                 showMsg(response.message, Constants.SnackBarType.Success);
//                 if (sendOTP == false) {
//                     setRSessionId((response.data.session_id !== undefined && response.data.session_id != null) ? response.data.session_id : null);
//                     setRCPassword(conPass);
//                     setRFirstName(firstname);
//                     setRLastName(lastname);
//                     setRPassword(password);
//                     setRUserName(username);
//                     setIsVerified(true);
//                     setSendOTP(true);
//                     setIsLoading(false);
//                 } else {
//                     onVerifyEmailToHome();
//                 }
//             } else if (response.status == 422) {
//                 var arr = [];
//                 arr = Object.keys(response.message).map(key => response.message[key][0]);
//                 setIsLoading(false);
//                 showMsg(arr, Constants.SnackBarType.Warning);
//             } else {
//                 setIsLoading(false);
//                 showMsg(response.message, Constants.SnackBarType.Warning);
//             }
//         } else {
//             setIsLoading(false);
//             showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
//         }
//     };

//     const onRegisterPressHandle = async () => {
//         if (sendOTP) {
//             if (!otp) {
//                 return showMsg("Please enter OTP", Constants.SnackBarType.Warning);
//             }
//             onRegister(rFirstName, rLastName, rUserName, rPassword, rCPassword, otp);
//         } else {
//             const error = validateRegisterForm();
//             if (error) return showMsg(error, Constants.SnackBarType.Warning);
//             onRegister(rFirstName, rLastName, rUserName, rPassword, rCPassword, "");
//         }
//     };

//     const showMsg = (message, type) => {
//         setMessage(message);
//         setMsgType(type);
//         setOpen(true);
//         setTimeout(() => setOpen(false), 6000);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     return (
//         <>
//             {/* Toast Notification */}
//             {open && (
//                 <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 9999 }}>
//                     <div className={`alert alert-${msgType === 'success' ? 'success' : msgType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`} role="alert">
//                         <strong>{message}</strong>
//                         <button type="button" className="btn-close" onClick={handleClose}></button>
//                     </div>
//                 </div>
//             )}

//             <div className="container-fluid p-0 m-0" style={{ height: '100vh', overflow: 'hidden' }}>
//                 <div className="row g-0 h-100">
//                     {/* Left Side - Image */}
//                     <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center bg-light">
//                         <img 
//                             src={LoginScreen} 
//                             alt="Login" 
//                             style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain' }}
//                         />
//                     </div>

//                     {/* Right Side - Form */}
//                     <div className="col-lg-6 d-flex flex-column" style={{ backgroundColor: '#B0010D', minHeight: '100vh', overflow: 'auto' }}>
//                         <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 p-4">
//                             {/* Logo */}
//                             <div className="mb-4">
//                                 <img src={Logo} alt="eSIM NEW ZEALAND" style={{ width: '180px', height: 'auto' }} />
//                             </div>

//                             {/* Tab Navigation */}
//                             <div className="d-flex mb-4 rounded-pill overflow-hidden" style={{ width: '100%', maxWidth: '450px', backgroundColor: 'rgba(255,255,255,0.2)' }}>
//                                 <button
//                                     className={`btn flex-fill py-2 border-0 fw-semibold ${isLogin ? 'bg-white text-danger' : 'text-white'}`}
//                                     style={{ 
//                                         borderRadius: '50px 0 0 50px',
//                                         fontSize: '18px',
//                                         transition: 'all 0.3s'
//                                     }}
//                                     onClick={() => {
//                                         setIsLogin(true);
//                                         setSendOTP(false);
//                                     }}
//                                     disabled={isLoading}
//                                 >
//                                     Login
//                                 </button>
//                                 <button
//                                     className={`btn flex-fill py-2 border-0 fw-semibold ${!isLogin ? 'bg-white text-danger' : 'text-white'}`}
//                                     style={{ 
//                                         borderRadius: '0 50px 50px 0',
//                                         fontSize: '18px',
//                                         transition: 'all 0.3s'
//                                     }}
//                                     onClick={() => {
//                                         setIsLogin(false);
//                                         setSendOTP(false);
//                                     }}
//                                     disabled={isLoading}
//                                 >
//                                     Register
//                                 </button>
//                             </div>

//                             {/* Forms Container */}
//                             <div className="w-100" style={{ maxWidth: '450px' }}>
//                                 {isLogin ? (
//                                     /* ===== LOGIN FORM ===== */
//                                     <div>
//                                         <h2 className="mb-4 text-white fw-bold">Log In</h2>
                                        
//                                         <div className="mb-3">
//                                             <input
//                                                 type="email"
//                                                 name="email"
//                                                 className="form-control form-control-lg border-0"
//                                                 placeholder="Username"
//                                                 autoComplete="new-password"
//                                                 value={email}
//                                                 onChange={(e) => setEmail(e.target.value)}
//                                                 disabled={isLoading}
//                                                 style={{ 
//                                                     padding: '18px 20px',
//                                                     borderRadius: '12px',
//                                                     backgroundColor: 'rgba(255,255,255,0.9)',
//                                                     color: '#dc3545',
//                                                     fontSize: '16px'
//                                                 }}
//                                             />
//                                         </div>

//                                         <div className="mb-4">
//                                             <input
//                                                 type={showPassword ? "text" : "password"}
//                                                 name="password"
//                                                 className="form-control form-control-lg border-0"
//                                                 placeholder="Password"
//                                                 value={password}
//                                                 onChange={(e) => setPassword(e.target.value)}
//                                                 disabled={isLoading}
//                                                 autoComplete="new-password"
//                                                 style={{ 
//                                                     padding: '18px 20px',
//                                                     borderRadius: '12px',
//                                                     backgroundColor: 'rgba(255,255,255,0.9)',
//                                                     color: '#dc3545',
//                                                     fontSize: '16px'
//                                                 }}
//                                             />
//                                         </div>

//                                         <button
//                                             type="button"
//                                             className="btn btn-light btn-lg w-100 fw-bold text-danger border-0 shadow"
//                                             onClick={onLoginPressHandle}
//                                             disabled={isLoading}
//                                             style={{ 
//                                                 fontSize: '18px',
//                                                 padding: '15px',
//                                                 borderRadius: '12px'
//                                             }}
//                                         >
//                                             {isLoading ? 'Signing In...' : 'Login'}
//                                         </button>

//                                         <div className="text-center mt-3">
//                                             <Link to="/ForgotPassword" className="text-white text-decoration-none small">
//                                                 Forgot Password?
//                                             </Link>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     /* ===== REGISTER FORM ===== */
//                                     <div>
//                                         <h2 className="mb-4 text-white fw-bold">
//                                             {sendOTP ? 'Verify OTP' : 'Register'}
//                                         </h2>

//                                         {!sendOTP ? (
//                                             <>
//                                                 <div className="row g-2 mb-3">
//                                                     <div className="col-6">
//                                                         <input
//                                                             type="text"
//                                                             className="form-control form-control-lg border-0"
//                                                             placeholder="First Name"
//                                                             value={rFirstName}
//                                                             onChange={(e) => setRFirstName(e.target.value)}
//                                                             disabled={isLoading}
//                                                             style={{ 
//                                                                 padding: '15px',
//                                                                 borderRadius: '12px',
//                                                                 backgroundColor: 'rgba(255,255,255,0.9)',
//                                                                 color: '#dc3545'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                     <div className="col-6">
//                                                         <input
//                                                             type="text"
//                                                             className="form-control form-control-lg border-0"
//                                                             placeholder="Last Name"
//                                                             value={rLastName}
//                                                             onChange={(e) => setRLastName(e.target.value)}
//                                                             disabled={isLoading}
//                                                             autoComplete="new-password"
//                                                             style={{ 
//                                                                 padding: '15px',
//                                                                 borderRadius: '12px',
//                                                                 backgroundColor: 'rgba(255,255,255,0.9)',
//                                                                 color: '#dc3545'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                 </div>

//                                                 <div className="mb-3">
//                                                     <input
//                                                         type="email"
//                                                         className="form-control form-control-lg border-0"
//                                                         placeholder="Email Address"
//                                                         value={rUserName}
//                                                         onChange={(e) => setRUserName(e.target.value)}
//                                                         disabled={isLoading}
//                                                         autoComplete="new-password"
//                                                         style={{ 
//                                                             padding: '15px',
//                                                             borderRadius: '12px',
//                                                             backgroundColor: 'rgba(255,255,255,0.9)',
//                                                             color: '#dc3545'
//                                                         }}
//                                                     />
//                                                 </div>

//                                                 <div className="row g-2 mb-4">
//                                                     <div className="col-6">
//                                                         <input
//                                                             type="password"
//                                                             className="form-control form-control-lg border-0"
//                                                             placeholder="Password"
//                                                             autoComplete="new-password"
//                                                             value={rPassword}
//                                                             onChange={(e) => setRPassword(e.target.value)}
//                                                             disabled={isLoading}
//                                                             style={{ 
//                                                                 padding: '15px',
//                                                                 borderRadius: '12px',
//                                                                 backgroundColor: 'rgba(255,255,255,0.9)',
//                                                                 color: '#dc3545'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                     <div className="col-6">
//                                                         <input
//                                                             type="password"
//                                                             className="form-control form-control-lg border-0"
//                                                             placeholder="Confirm"
//                                                             autoComplete="new-password"
//                                                             value={rCPassword}
//                                                             onChange={(e) => setRCPassword(e.target.value)}
//                                                             disabled={isLoading}
//                                                             style={{ 
//                                                                 padding: '15px',
//                                                                 borderRadius: '12px',
//                                                                 backgroundColor: 'rgba(255,255,255,0.9)',
//                                                                 color: '#dc3545'
//                                                             }}
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             </>
//                                         ) : (
//                                             <div className="mb-4">
//                                                 <input
//                                                     type="text"
//                                                     className="form-control form-control-lg border-0 text-center"
//                                                     placeholder="Enter OTP"
//                                                     autoComplete="new-password"
//                                                     value={otp}
//                                                     onChange={(e) => setOtp(e.target.value)}
//                                                     disabled={isLoading}
//                                                     maxLength={6}
//                                                     style={{ 
//                                                         padding: '15px',
//                                                         borderRadius: '12px',
//                                                         backgroundColor: 'rgba(255,255,255,0.9)',
//                                                         color: '#dc3545',
//                                                         fontSize: '20px',
//                                                         letterSpacing: '8px',
//                                                         fontWeight: '600'
//                                                     }}
//                                                 />
//                                                 <small className="text-white d-block mt-2 text-center">
//                                                     OTP sent to {rUserName}
//                                                 </small>
//                                             </div>
//                                         )}

//                                         <button
//                                             type="button"
//                                             className="btn btn-light btn-lg w-100 fw-bold text-danger border-0 shadow"
//                                             onClick={onRegisterPressHandle}
//                                             disabled={isLoading}
//                                             style={{ 
//                                                 fontSize: '18px',
//                                                 padding: '15px',
//                                                 borderRadius: '12px'
//                                             }}
//                                         >
//                                             {isLoading ? 'Processing...' : sendOTP ? 'Verify' : 'Register'}
//                                         </button>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Auth;


import * as React from 'react';
import { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setUserSession, getApiHeaderGuest } from '../../utils/CommonFunctions';
import { Link } from "react-router-dom";
import { UserAPI } from '../../services';
import { Validate, Constants, Languages } from '../../common';
import { actions } from '../../redux/UserRedux';
import LoginScreen from "../../../src/assets/img/setimg.png";
import Logo from "../../../src/assets/img/logowhite.png";

const headers = getApiHeaderGuest();

const Auth = () => {
    const dispatch = useDispatch();

    // State variables
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLogin, setIsLogin] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState(Constants.SnackBarType.Error);
    
    // Register fields
    const [rFirstName, setRFirstName] = useState("");
    const [rLastName, setRLastName] = useState("");
    const [rUserName, setRUserName] = useState("");
    const [rPassword, setRPassword] = useState("");
    const [rCPassword, setRCPassword] = useState("");
    const [rSessionId, setRSessionId] = useState(null);
    const [isVerified, setIsVerified] = useState(false);
    const [sendOTP, setSendOTP] = useState(false);
    const [otp, setOtp] = useState("");

    // Redux actions
    const clearData = useCallback(() => {
        dispatch(actions.clearData());
    }, [dispatch]);

    const notAvailable = useCallback(() => {
        actions.notAvailable(dispatch);
    }, [dispatch]);

    const setActivationId = useCallback((activationId, eSIMName) => {
        dispatch(actions.setActivationId(activationId, eSIMName));
    }, [dispatch]);

    // Validation functions
    const validateForm = () => {
        if (Validate.isEmpty(email, password)) {
            return Languages.LoginError;
        } else if (!Validate.isEmail(email)) {
            return Languages.EmailError;
        }
        return undefined;
    };

    const validateRegisterForm = () => {
        if (Validate.isEmpty(rFirstName, rLastName, rUserName, rPassword, rCPassword)) {
            return "All fields are required";
        } else if (!Validate.isEmail(rUserName)) {
            return Languages.EmailError;
        } else if (rPassword !== rCPassword) {
            return "Passwords do not match";
        }
        return undefined;
    };

    // API call functions
    const getActivations = async (headers) => {
        setIsLoading(true);
        const response = await UserAPI.postData({}, headers, Constants.UserActivations);
        console.log('UserActivations ==>', response);
        if (response !== undefined) {
            if (response.status == 200) {
                if (response.data.activations.length > 0) {
                    let data = response.data.activations;
                    let esim_Name = '';
                    let activation_Id = 0;
                    if (data.length > 0) {
                        esim_Name = data[0].country_name + ' - ' + data[0].iccid;
                        activation_Id = data[0].activation_id;
                    }
                    await setActivationId(activation_Id, esim_Name);
                } else {
                    await notAvailable();
                }
            } else {
                showMsg(response.message, Constants.SnackBarType.Warning);
            }
        } else {
            showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
        }
    };

    const gotoHome = async (response) => {
        const header = await {
            'Authorization': 'Bearer ' + response.data.token,
            'api-token': Constants.ApiToken,
            'device-type': 'Web'
        };
        getActivations(header);
        setIsLoading(true);
        let p = new Promise((resolve, reject) => {
            setUserSession(response.data.token, response.data.user);
            resolve();
        });
        p.then(
            () => {
                setIsLoading(false);
                setSendOTP(false);
                window.location.href = "/home";
            },
            () => {
                setIsLoading(false);
                showMsg("Error in Login", Constants.SnackBarType.Warning);
            }
        );
    };

    const onLogin = async (username, password) => {
        setIsLoading(true);
        await clearData();
        const data = {
            username: username,
            password: password
        };
        const response = await UserAPI.postData(data, headers, Constants.Login);
        console.log('login ==>', response);
        if (response !== undefined) {
            if (response.status == 200) {
                showMsg(response.message, Constants.SnackBarType.Success);
                gotoHome(response);
            } else if (response.status == 422) {
                var arr = [];
                arr = Object.keys(response.message).map(key => response.message[key][0]);
                setIsLoading(false);
                showMsg(arr, Constants.SnackBarType.Warning);
            } else {
                setIsLoading(false);
                showMsg(response.message, Constants.SnackBarType.Warning);
            }
        } else {
            setIsLoading(false);
            showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
        }
    };

    const onLoginPressHandle = async () => {
        const error = validateForm();
        if (error) return showMsg(error, Constants.SnackBarType.Warning);
        onLogin(email, password);
    };

    const onVerifyEmailToHome = async () => {
        setIsLoading(true);
        var data = {
            firstname: rFirstName,
            lastname: rLastName,
            email: rUserName,
            password: rPassword,
            password_confirmation: rCPassword,
            session_id: rSessionId
        };
        var url = Constants.VerifyeSIM;
        const response = await UserAPI.postData(data, headers, url);
        if (response !== undefined) {
            if (response.status == 200) {
                showMsg(response.message, Constants.SnackBarType.Success);
                gotoHome(response);
                setIsLoading(false);
            } else if (response.status == 422) {
                var arr = [];
                arr = Object.keys(response.message).map(key => response.message[key][0]);
                setIsLoading(false);
                showMsg(arr, Constants.SnackBarType.Warning);
            } else {
                setIsLoading(false);
                showMsg(response.message, Constants.SnackBarType.Warning);
            }
        } else {
            setIsLoading(false);
            showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
        }
    };

    const onRegister = async (firstname, lastname, username, password, conPass, otpValue) => {
        setIsLoading(true);
        await clearData();
        var data = {
            firstname: firstname,
            lastname: lastname,
            email: username,
            password: password,
            password_confirmation: conPass
        };
        var url = Constants.Register;
        
        if (sendOTP == true && username == rUserName && password == rPassword) {
            data = {
                email: rUserName,
                otp: otpValue,
                session_id: rSessionId
            };
            url = Constants.VerifyRegisterOTP;
        }
        
        const response = await UserAPI.postData(data, headers, url);
        console.log('Register ==>', response);
        if (response !== undefined) {
            if (response.status == 200) {
                showMsg(response.message, Constants.SnackBarType.Success);
                if (sendOTP == false) {
                    setRSessionId((response.data.session_id !== undefined && response.data.session_id != null) ? response.data.session_id : null);
                    setRCPassword(conPass);
                    setRFirstName(firstname);
                    setRLastName(lastname);
                    setRPassword(password);
                    setRUserName(username);
                    setIsVerified(true);
                    setSendOTP(true);
                    setIsLoading(false);
                } else {
                    onVerifyEmailToHome();
                }
            } else if (response.status == 422) {
                var arr = [];
                arr = Object.keys(response.message).map(key => response.message[key][0]);
                setIsLoading(false);
                showMsg(arr, Constants.SnackBarType.Warning);
            } else {
                setIsLoading(false);
                showMsg(response.message, Constants.SnackBarType.Warning);
            }
        } else {
            setIsLoading(false);
            showMsg(Languages.ServerError, Constants.SnackBarType.Warning);
        }
    };

    const onRegisterPressHandle = async () => {
        if (sendOTP) {
            if (!otp) {
                return showMsg("Please enter OTP", Constants.SnackBarType.Warning);
            }
            onRegister(rFirstName, rLastName, rUserName, rPassword, rCPassword, otp);
        } else {
            const error = validateRegisterForm();
            if (error) return showMsg(error, Constants.SnackBarType.Warning);
            onRegister(rFirstName, rLastName, rUserName, rPassword, rCPassword, "");
        }
    };

    const showMsg = (message, type) => {
        setMessage(message);
        setMsgType(type);
        setOpen(true);
        setTimeout(() => setOpen(false), 6000);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {/* Toast Notification */}
            {open && (
                <div className="position-fixed top-0 start-50 translate-middle-x mt-3" style={{ zIndex: 9999 }}>
                    <div className={`alert alert-${msgType === 'success' ? 'success' : msgType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`} role="alert">
                        <strong>{message}</strong>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                </div>
            )}

            <div className="container-fluid p-0 m-0" style={{ height: '100vh', overflow: 'hidden' }}>
                <div className="row g-0 h-100">
                    {/* Left Side - Image */}
                    <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center bg-light">
                        <img 
                            src={LoginScreen} 
                            alt="Login" 
                            style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain' }}
                        />
                    </div>

                    {/* Right Side - Form */}
                    <div className="col-lg-6 d-flex flex-column" style={{ backgroundColor: '#B0010D', minHeight: '100vh', overflow: 'auto' }}>
                        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 p-4">
                            {/* Logo */}
                            <div className="mb-4">
                                <img src={Logo} alt="eSIM NEW ZEALAND" style={{ width: '180px', height: 'auto' }} />
                            </div>

                            {/* Tab Navigation */}
                            <div className="d-flex mb-4 rounded-pill overflow-hidden" style={{ width: '100%', maxWidth: '450px', backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                <button
                                    className={`btn flex-fill py-2 border-0 fw-semibold ${isLogin ? 'bg-white text-danger' : 'text-white'}`}
                                    style={{ 
                                        borderRadius: '50px 0 0 50px',
                                        fontSize: '18px',
                                        transition: 'all 0.3s'
                                    }}
                                    onClick={() => {
                                        setIsLogin(true);
                                        setSendOTP(false);
                                    }}
                                    disabled={isLoading}
                                >
                                    Login
                                </button>
                                <button
                                    className={`btn flex-fill py-2 border-0 fw-semibold ${!isLogin ? 'bg-white text-danger' : 'text-white'}`}
                                    style={{ 
                                        borderRadius: '0 50px 50px 0',
                                        fontSize: '18px',
                                        transition: 'all 0.3s'
                                    }}
                                    onClick={() => {
                                        setIsLogin(false);
                                        setSendOTP(false);
                                    }}
                                    disabled={isLoading}
                                >
                                    Register
                                </button>
                            </div>

                            {/* Forms Container */}
                            <div className="w-100" style={{ maxWidth: '450px' }}>
                                {isLogin ? (
                                    /* ===== LOGIN FORM ===== */
                                    <div>
                                        {/* <h2 className="mb-4 text-white fw-bold">Log In</h2> */}
                                        
                                        <div className="mb-3">
                                            <label className="form-label text-white fw-semibold">
                                                Username <span style={{ color: '#ff4444' }}>*</span>
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control form-control-lg border-0"
                                                placeholder="Enter your email"
                                                autoComplete="new-password"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                disabled={isLoading}
                                                style={{ 
                                                    padding: '18px 20px',
                                                    borderRadius: '12px',
                                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                                    color: '#333',
                                                    fontSize: '16px'
                                                }}
                                            />
                                        </div>

                                        <div className="mb-4">
                                            <label className="form-label text-white fw-semibold">
                                                Password <span style={{ color: '#ff4444' }}>*</span>
                                            </label>
                                            <div className="position-relative">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    name="password"
                                                    className="form-control form-control-lg border-0"
                                                    placeholder="Enter your password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    disabled={isLoading}
                                                    autoComplete="new-password"
                                                    style={{ 
                                                        padding: '18px 50px 18px 20px',
                                                        borderRadius: '12px',
                                                        backgroundColor: 'rgba(255,255,255,0.9)',
                                                        color: '#333',
                                                        fontSize: '16px'
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn border-0 position-absolute"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        background: 'transparent',
                                                        padding: '5px 10px'
                                                    }}
                                                >
                                                    {showPassword ? (
                                                        <svg width="20" height="20" fill="#666" viewBox="0 0 16 16">
                                                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                                                            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
                                                            <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
                                                        </svg>
                                                    ) : (
                                                        <svg width="20" height="20" fill="#666" viewBox="0 0 16 16">
                                                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                                                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                                        </svg>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-light btn-lg w-100 fw-bold text-danger border-0 shadow"
                                            onClick={onLoginPressHandle}
                                            disabled={isLoading}
                                            style={{ 
                                                fontSize: '18px',
                                                padding: '15px',
                                                borderRadius: '12px'
                                            }}
                                        >
                                            {isLoading ? 'Signing In...' : 'Login'}
                                        </button>

                                        <div className="text-center mt-3">
                                            <Link to="/ForgotPassword" className="text-white text-decoration-none small">
                                                Forgot Password?
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    /* ===== REGISTER FORM ===== */
                                    <div>
                                        <h2 className="mb-4 text-white fw-bold">
                                            {sendOTP ? 'Verify OTP' : ''}
                                        </h2>

                                        {!sendOTP ? (
                                            <>
                                                <div className="row g-2 mb-3">
                                                    <div className="col-6">
                                                        <label className="form-label text-white fw-semibold small">
                                                            First Name <span style={{ color: '#ff4444' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-lg border-0"
                                                            placeholder="First Name"
                                                            value={rFirstName}
                                                            onChange={(e) => setRFirstName(e.target.value)}
                                                            disabled={isLoading}
                                                            style={{ 
                                                                padding: '15px',
                                                                borderRadius: '12px',
                                                                backgroundColor: 'rgba(255,255,255,0.9)',
                                                                color: '#333'
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <label className="form-label text-white fw-semibold small">
                                                            Last Name <span style={{ color: '#ff4444' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-lg border-0"
                                                            placeholder="Last Name"
                                                            value={rLastName}
                                                            onChange={(e) => setRLastName(e.target.value)}
                                                            disabled={isLoading}
                                                            autoComplete="new-password"
                                                            style={{ 
                                                                padding: '15px',
                                                                borderRadius: '12px',
                                                                backgroundColor: 'rgba(255,255,255,0.9)',
                                                                color: '#333'
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label text-white fw-semibold">
                                                        Email Address <span style={{ color: '#ff4444' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control form-control-lg border-0"
                                                        placeholder="Enter your email"
                                                        value={rUserName}
                                                        onChange={(e) => setRUserName(e.target.value)}
                                                        disabled={isLoading}
                                                        autoComplete="new-password"
                                                        style={{ 
                                                            padding: '15px',
                                                            borderRadius: '12px',
                                                            backgroundColor: 'rgba(255,255,255,0.9)',
                                                            color: '#333'
                                                        }}
                                                    />
                                                </div>

                                                <div className="row g-2 mb-4">
                                                    <div className="col-6">
                                                        <label className="form-label text-white fw-semibold small">
                                                            Password <span style={{ color: '#ff4444' }}>*</span>
                                                        </label>
                                                        <div className="position-relative">
                                                            <input
                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control form-control-lg border-0"
                                                                placeholder="Password"
                                                                autoComplete="new-password"
                                                                value={rPassword}
                                                                onChange={(e) => setRPassword(e.target.value)}
                                                                disabled={isLoading}
                                                                style={{ 
                                                                    padding: '15px 40px 15px 15px',
                                                                    borderRadius: '12px',
                                                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                                                    color: '#333'
                                                                }}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn border-0 position-absolute"
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                style={{
                                                                    right: '5px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    background: 'transparent',
                                                                    padding: '5px'
                                                                }}
                                                            >
                                                                {showPassword ? (
                                                                    <svg width="18" height="18" fill="#666" viewBox="0 0 16 16">
                                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
                                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
                                                                        <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
                                                                    </svg>
                                                                ) : (
                                                                    <svg width="18" height="18" fill="#666" viewBox="0 0 16 16">
                                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
                                                                    </svg>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <label className="form-label text-white fw-semibold small">
                                                            Confirm <span style={{ color: '#ff4444' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="password"
                                                            className="form-control form-control-lg border-0"
                                                            placeholder="Confirm"
                                                            autoComplete="new-password"
                                                            value={rCPassword}
                                                            onChange={(e) => setRCPassword(e.target.value)}
                                                            disabled={isLoading}
                                                            style={{ 
                                                                padding: '15px',
                                                                borderRadius: '12px',
                                                                backgroundColor: 'rgba(255,255,255,0.9)',
                                                                color: '#333'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="mb-4">
                                                <label className="form-label text-white fw-semibold">
                                                    OTP Code <span style={{ color: '#ff4444' }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg border-0 text-center"
                                                    placeholder="Enter OTP"
                                                    autoComplete="new-password"
                                                    value={otp}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    disabled={isLoading}
                                                    maxLength={6}
                                                    style={{ 
                                                        padding: '15px',
                                                        borderRadius: '12px',
                                                        backgroundColor: 'rgba(255,255,255,0.9)',
                                                        color: '#333',
                                                        fontSize: '20px',
                                                        letterSpacing: '8px',
                                                        fontWeight: '600'
                                                    }}
                                                />
                                                <small className="text-white d-block mt-2 text-center">
                                                    OTP sent to {rUserName}
                                                </small>
                                            </div>
                                        )}

                                        <button
                                            type="button"
                                            className="btn btn-light btn-lg w-100 fw-bold text-danger border-0 shadow"
                                            onClick={onRegisterPressHandle}
                                            disabled={isLoading}
                                            style={{ 
                                                fontSize: '18px',
                                                padding: '15px',
                                                borderRadius: '12px'
                                            }}
                                        >
                                            {isLoading ? 'Processing...' : sendOTP ? 'Verify' : 'Register'}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Auth;

